// src/services/ingredientService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  INGREDIENT_LIST,
  INGREDIENT_ADD,
  INGREDIENT_UPDATE,
  INGREDIENT_DELETE,
  INGREDIENT_EXPORT,
  INGREDIENT_IMPORT,
  INGREDIENT_SAMPLE_FILE,
  INGREDIENT_ALL_DELETE
} from "../../config/constants"; // Adjust endpoints as per your config

const ingredientService = createApi({
  reducerPath: "ingredientService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Ingredient"],
  endpoints: (builder) => ({
    getIngredients: builder.query({
      query: (bodyData) => ({
        url: INGREDIENT_LIST, // Endpoint to fetch ingredient list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Ingredient"],
    }),
    getIngredientsExportFile: builder.mutation({
      query: (bodyData) => ({
        url: INGREDIENT_EXPORT, // Endpoint to fetch ingredient list
        method: "GET",
      }),
    }),
    addIngredient: builder.mutation({
      query: (ingredientData) => ({
        url: INGREDIENT_ADD, // Endpoint to add a ingredient
        method: "POST",
        data: ingredientData, // Ingredient data for the request body
      }),
      invalidatesTags: ["Ingredient"],
    }),
    updateIngredient: builder.mutation({
      query: ({ ingredientId, updatedData }) => ({
        url: `${INGREDIENT_UPDATE}/${ingredientId}`, // Endpoint to update a ingredient
        method: "PUT",
        data: updatedData, // Updated ingredient data
      }),
      invalidatesTags: ["Ingredient"],
    }),
    deleteIngredient: builder.mutation({
      query: (ingredientId) => ({
        url: `${INGREDIENT_DELETE}/${ingredientId}`, // Endpoint to delete a ingredient
        method: "DELETE",
      }),
      invalidatesTags: ["Ingredient"],
    }),
    deleteAllIngredient: builder.mutation({
      query: (bodyData) => ({
      //  url: `${INGREDIENT_DELETE}/${ingredientId}`, // Endpoint to delete a ingredient
        url: INGREDIENT_ALL_DELETE,
        method: "DELETE",
      }),
      invalidatesTags: ["Ingredient"],
    }),

    importIngredient: builder.mutation({
      query: (data) => ({
        url: `${INGREDIENT_IMPORT}`, // Endpoint to update a settings
        method: "POST",
        data: data, // Updated settings data
        headers: {
          "content-type": "multipart/form-data",
        },
      }),
      invalidatesTags: ["Ingredient"],
    }),
    downloadSampleFile: builder.mutation({
      query: (bodyData) => ({
        url: INGREDIENT_SAMPLE_FILE, // Endpoint to fetch ingredient list
        method: "GET",
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetIngredientsQuery,
  useGetIngredientsExportFileMutation,
  useAddIngredientMutation,
  useUpdateIngredientMutation,
  useDeleteIngredientMutation,
  useDeleteAllIngredientMutation,
  useImportIngredientMutation,
  useDownloadSampleFileMutation,
} = ingredientService;

// Export the reducer to be included in the store
export default ingredientService;
